// extracted by mini-css-extract-plugin
export default {"listHeader":"participants_list-module___listHeader___cf249725","list":"participants_list-module___list___c8faae3d"};